import {
  Project,
  Identifiable,
  Zone,
  projectStatus,
  Planzone,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedList, LinkedProject, Linker } from "../linkers/types";
import { formatDate } from "../utils/formatDate";

function getTemplateZone(httpClient: HttpClient) {
  return () =>
    httpClient
      .sendHttpRequest<Identifiable<Planzone>>({
        endpoint: "/planzones/current",
        method: HttpMethods.GET,
      })
      .then((planzone) =>
        httpClient
          .sendHttpRequest<{
            _embedded: {
              zones: (Identifiable<Zone> & { savingTemplates: boolean })[];
            };
          }>({
            endpoint: `/zones/search/rsql?query=planzone.uuid==${planzone.uuid} and savingTemplates==true`,
            method: HttpMethods.GET,
          })
          .then(({ _embedded }) =>
            _embedded.zones.find(({ savingTemplates }) => savingTemplates),
          )
          .then((zone) => (zone ? zone : Promise.reject())),
      );
}

function saveProject(httpClient: HttpClient, linker: Linker) {
  return (zone: Identifiable<Zone>, { uuid, rootList, ...project }: Project) =>
    new Promise<Identifiable<Project>>((resolve, reject) =>
      (project.isTemplate
        ? getTemplateZone(httpClient)()
        : Promise.resolve(zone)
      ).then((zone) =>
        httpClient
          .sendHttpRequest<LinkedProject>({
            endpoint: `/projects`,
            method: HttpMethods.POST,
            headers: {
              ...(rootList.startDate && {
                startDate: formatDate(rootList.startDate),
              }),
              ...(rootList.endDate && {
                endDate: formatDate(rootList.endDate),
              }),
            },
            data: {
              name: project.name,
              description: project.description,
              zone: `/zones/${zone.uuid}`,
              status: `projectStatuses/${project.status.uuid}`,
              tags: project.tags.map(({ name }) => name),
              template: project.isTemplate,
              attributes: project.attributes,
              data: {
                externalLinks: JSON.stringify({}),
              },
            },
          })
          .then(linker.linkProject)
          .then((project) =>
            resolve({
              ...project,
              status: project.status || projectStatus,
              // @ts-ignore
              isTemplate: project.isTemplate || (project.template as boolean),
            }),
          )
          .catch((e) => reject({ ...e, message: e.detail || "" })),
      ),
    );
}

export { saveProject };
